import {
  Component,
  OnInit,
  OnChanges,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { QuestionnaireService } from "app/services/questionnaire.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "app/services/helper.service";
import { TosterMessageService } from "app/services/toster-message.service";
import { NgForm } from "@angular/forms";
import { QuestionBankService } from "../../services/question-bank.service";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
import { UploadService } from "app/services/upload.service";

@Component({
  selector: "app-question-bank-add-new-written-modal",
  templateUrl: "./question-bank-add-new-written-modal.component.html",
  styleUrls: ["./question-bank-add-new-written-modal.component.scss"],
  providers: [QuestionBankService],
})
export class QuestionBankNewQueAddWrittenComponent implements OnInit, OnChanges {
  base64Image: string | undefined;
  selectedFile: any = {};
  selectedImage: any = {};

  answerForm: FormGroup;
  sortOrder: number = 0;
  entity: any = {};
  correctAnsweIndex: number;

  public masterData: any = {};
  formData = {
    media_type: "",
    answer: "",
    marks: "",
    media_link: "",
    auto_id: "",
  };
  mediaType = [
    { value: 1, label: "Active" },
    { value: 0, label: "Not Active" },
  ];

  isLoading = false;
  isHide: any = 1;

  isEdit: number;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @Input() auto_id: number;
  @Input() header_id_2: number;

  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("swalWaitModal") swalWaitModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private QuestionBankService: QuestionBankService,
    private frmbuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private UploadService: UploadService
  ) { }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  showWaitHtml() {
    setTimeout(() => {
      this.swalWaitModal.show();
    }, 0);
  }


  onMediaTypeChange($event) {
    if ($event.target.value !== "1") {
      this.isHide = 0;
    } else {
      this.isHide = 1;
    }
  }


  ngOnInit() {
    this.auto_id = Number(localStorage.getItem("question-bank-edit-auto-id"));
    localStorage.removeItem("question-bank-edit-auto-id");
    this.header_id_2 = Number(localStorage.getItem("question-bank-edit-header-id"));
    localStorage.removeItem("file");

    setInterval(()=> { 
      if(localStorage.getItem("file")){
        this.isLoading = false;
      }
    }, 1500);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = false;
  }

  async onFileSelected(event: any) {
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    let response: any = await this.UploadService.uploadFile(this.selectedFile);
    // //console.log(response);
  }


  addWrittenAnswers(formData: any) {
        const requestData = {
          media_type: formData.media_type,
          marks: formData.marks,
          // media_link: localStorage.getItem("file"),
          media_link: formData.media_type === '3' ? formData.media_link : localStorage.getItem("file"),
          company_id: this.companySystemID,
          header_id: this.auto_id,
          header_detail_id: this.header_id_2,
        };
        localStorage.removeItem("file");
    
        let that = this;
        that.masterData.companySystemID = that.companySystemID;
        that.masterData.header_id = that.auto_id;
        that.QuestionBankService.createNewWrittenQuestionBank()
          .post(requestData)
          .subscribe(
            (resp: any) => {
              that.masterData = {};
              that.successMsg = "";
              that.successMsg = "Successfully added a new question";
              that.showSuccessHtml();
              that.closeModalAfterCreate();
              this.tableReload.emit();
            },
            (error) => {
              that.htmlErrorMessage = "";
              if (error.status == 500) {
                that.htmlErrorMessage = error.data.message;
                that.showErrorHtml();
              } else if (error.status == 422) {
                that.htmlErrorMessage = that.helperService.serverSideError422(
                  error.data.message
                );
                that.showErrorHtml();
              }
              this.tableReload.emit();
            }
          );
        this.tableReload.emit(); 
  }

}




// async onFileSelected (event: any) {
// //console.log(event.target.files);

// this.selectedFile = event.target.files[0];

// const imageInfoJSON = JSON.stringify(this.selectedFile);
// localStorage.setItem("imageInfo", imageInfoJSON);

// this.selectedImage = event.target.files[0];
// const reader = new FileReader();
// reader.onload = (e: any) => {
//   this.base64Image = e.target.result;
//   //console.log(this.base64Image);

//   if (this.base64Image) {
//     localStorage.setItem("base64Image", this.base64Image);
//   }
// };
// reader.readAsDataURL(this.selectedImage);
// }





    // this.helperService.readFile(this.selectedFile).then(fileContents => {
    //   let tem = this.selectedFile;
    //   let data = {
    //     name: tem.name,
    //     size: tem.size,
    //     type: tem.type,
    //     file: fileContents
    //   };
    //   if (this.selectedFile.size > 0) {
    //     //console.log(this.selectedFile.size);
    //   } 
    // });


// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-add-new-written-modal/question-bank-add-new-written-modal.component.ts